import { render } from "./AccountSettingAboutSystemIndex.vue?vue&type=template&id=13f6c33b"
import script from "./AccountSettingAboutSystemIndex.vue?vue&type=script&lang=js"
export * from "./AccountSettingAboutSystemIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__